/* Morgan & Reid — Volume Discount single-item tier (tier1) on product cards (collection pages).
 *
 * The PDP (bundle-builder.js v13/v15) shows the tier1 price with the original struck through when the store's discount config has tier1 on and the product sits in a
 * qualifying collection (and not an excluded one). This does the same for the card's "From" price, with no percentage written into the theme: it reads the same
 * /apps/mr-ec/api/bundle-discount-config (tier1.enabled/percent, qualifying and exclude collections), once per 10 minutes per browser.
 *
 * Each card carries a hidden marker (snippets/product-card.liquid) with the product's collection handles and its lowest price in cents. A card is changed only when:
 *   - the config is reachable and tier1 is on (else nothing changes: fail closed), and the product is in a qualifying collection and in no excluded one,
 *   - the card is not already on sale (price--on-sale) and the visitor's currency is the shop's currency (the money format is the shop's).
 * The discount is the PDP's: the percentage off ONE unit, rounded DOWN to the cent (what Shopify's Function does). The markup is the theme's own sale price
 * (snippets/product-price.liquid): price--on-sale, the discounted price in price__regular, the original in price__sale (struck through by the theme).
 */
(function () {
  "use strict";
  if (window.__mrCardTier) return;
  window.__mrCardTier = true;

  var API_BASE = "/apps/mr-ec";
  var SHOP = (window.Shopify && window.Shopify.shop) || "";
  var CACHE_KEY = "mr_card_tier_v1", CACHE_MS = 10 * 60 * 1000;

  // The store's own money format (theme.settings.moneyFormat), the same as bundle-builder.js.
  function mrMoney(cents, withCode) {
    var s = (window.theme && window.theme.settings) || {};
    var f = (withCode ? s.moneyWithCurrencyFormat : s.moneyFormat) || "${{amount}}";
    var n = (cents / 100).toFixed(2);
    if (/no_decimals/.test(f)) n = String(Math.round(cents / 100));
    if (/comma_separator/.test(f)) n = n.replace(".", ",");
    return f.replace(/\{\{\s*amount[^}]*\}\}/, n).replace(/<[^>]+>/g, "");
  }

  var cfgPromise = null;
  function loadConfig() {
    if (cfgPromise) return cfgPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
      if (c && c.at && Date.now() - c.at < CACHE_MS && c.cfg) return (cfgPromise = Promise.resolve(c.cfg));
    } catch (e) { /* no storage: fetch */ }
    cfgPromise = fetch(API_BASE + "/api/bundle-discount-config?shop=" + encodeURIComponent(SHOP))
      .then(function (r) { if (!r.ok) throw new Error("config " + r.status); return r.json(); })
      .then(function (cfg) { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), cfg: cfg })); } catch (e) { /* ignore */ } return cfg; })
      .catch(function () { return null; });
    return cfgPromise;
  }

  // Same as bundle-builder.js: the tier is ON only with enabled === true and 0 < percent < 10; one unit's saving is floored to the cent.
  function savingFor(cfg, cents) {
    var t = cfg && cfg.tier1;
    if (!t || t.enabled !== true || !(t.percent > 0 && t.percent < 10)) return 0;
    var pct = Math.round(t.percent * 10) / 1000;
    return Math.floor(cents * Math.round(pct * 1000) / 1000);
  }

  var handleSet = function (list) { var s = {}; (list || []).forEach(function (c) { if (c && c.handle) s[c.handle] = 1; }); return s; };

  function decorate(marker, cfg) {
    marker.setAttribute("data-done", "1");
    var price = marker.nextElementSibling;
    var plain = marker.hasAttribute("data-plain");   // a section that prints its own price in one element: only the number changes, no struck price
    if (!price || (!plain && (!price.classList.contains("price") || price.classList.contains("price--on-sale")))) return;
    if (marker.getAttribute("data-cur") !== marker.getAttribute("data-shop-cur")) return;
    var inQ = handleSet(cfg.qualifying), inX = handleSet(cfg.exclude);
    var handles = (marker.getAttribute("data-collections") || "").split(",").filter(Boolean);
    if (!handles.some(function (h) { return inQ[h]; }) || handles.some(function (h) { return inX[h]; })) return;
    var min = parseInt(marker.getAttribute("data-min"), 10);
    var off = min > 0 ? savingFor(cfg, min) : 0;
    var regular = plain ? price : price.querySelector(".price__regular");
    if (!(off > 0) || !regular) return;
    var withCode = /\b[A-Z]{3}\s*$/.test(regular.textContent.trim());
    var now = mrMoney(min - off, withCode), was = mrMoney(min, withCode);
    if (plain) { regular.textContent = regular.textContent.replace(was, now); return; }
    var from = marker.getAttribute("data-from");
    var esc = function (s) { return String(s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    regular.innerHTML = marker.getAttribute("data-varies") === "1" && from ? from.replace("__P__", now) : esc(now);
    regular.insertAdjacentHTML("beforebegin", '<span class="sr-only">' + esc(marker.getAttribute("data-sale-label")) + "</span>");
    regular.insertAdjacentHTML("afterend", '<span class="sr-only">' + esc(marker.getAttribute("data-regular-label")) + '</span><span class="price__sale inline-flex items-center h-auto relative">' + esc(was) + "</span>");
    price.classList.add("price--on-sale");
  }

  var queued = false;
  function run() {
    queued = false;
    var markers = document.querySelectorAll("[data-mr-card-tier]:not([data-done])");
    if (!markers.length) return;
    loadConfig().then(function (cfg) {
      if (!cfg) return;
      document.querySelectorAll("[data-mr-card-tier]:not([data-done])").forEach(function (m) { decorate(m, cfg); });
    });
  }
  function queue() { if (!queued) { queued = true; setTimeout(run, 30); } }

  // Cards arrive after load too (filters, load more): decorate whatever appears.
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", queue); else queue();
})();
